/**
 * Configuration de l'API pour le Dashboard de Production
 */

import Storage from '@/shared/utils/storage.js';

export const API_CONFIG = {
  baseURL: 'https://api.monrapidoo.com',
  timeout: 30000
};

export const USER_API_CONFIG = {
  baseURL: 'https://api.monrapidoo.com/user',
  serviceName: 'rapidoo-admin',
  serviceGroup: 'ultraxeno',
};

export const ADMIN_ENDPOINTS = {
  // Dashboard
  DASHBOARD_STATS: '/admin/dashboard/stats',
  DASHBOARD_ANALYTICS: '/admin/dashboard/analytics',
  DASHBOARD_ACTIVITIES: '/admin/dashboard/activities',

  // Orders - MonRapidoo API V3
  ORDERS_LIST: '/order/list',
  ORDER_CREATE: '/order/create',
  ORDER_DETAILS: '/order/details/:orderId',
  ORDER_UPDATE_STATUS: '/order/update/status',
  ORDER_PICKUP: '/order/pickup',
  ORDER_CANCEL: '/order/cancel',
  ORDER_SUBMIT_REVIEW: '/order/submit/review',
  ORDER_RESTAURANT_STATS: '/order/restaurant/stats',
  ORDER_USER_STATS: '/order/user/stats',
  ORDER_PAYMENTS: '/order/payments',

  // Packages
  ADMIN_PACKAGES: '/package/list?group=ultraxeno',
  ADMIN_UPDATE_PACKAGE_STATUS: '/package/update/status?group=ultraxeno',
  ADMIN_ASSIGN_PACKAGE_RIDER: '/package/assign/rider?group=ultraxeno',

  // Resources
  ADMIN_RESTAURANTS: '/rapidoo-aggregation/admin/restaurants',
  ADMIN_RESTAURANT_DETAIL: '/restaurant/details/:restaurantId',
  ADMIN_RESTAURANT_STATUS: '/admin/restaurants/:restaurantId/status',
  ADMIN_CUSTOMERS: '/rapidoo-aggregation/app-users',
  ADMIN_CUSTOMER_DELETE: '/admin/customers/:customerId',
  ADMIN_CUSTOMER_STATUS: '/admin/customers/:customerId/status',
  ADMIN_RIDERS: '/rapidoo-aggregation/admin/riders',
  ADMIN_RIDERS_LIVE: '/rider/list',

  ADMIN_RIDER_STATS: '/admin/riders/stats',
  ADMIN_RIDER_STATUS: '/rider/toggle/status/:riderId',
  ADMIN_RIDER_WARNINGS: '/admin/riders/:riderId/warnings',
  ADMIN_RIDER_FINES: '/admin/riders/:riderId/fines',
  ADMIN_RIDER_UPDATE: '/rider/update/:riderId',
  // Role Management
  ADMIN_ROLES: '/role-management/roles',
  ADMIN_ROLE_ADD: '/role-management/add/role',
  ADMIN_ROLE_UPDATE: '/role-management/update/roles',
  ADMIN_ROLE_DELETE: '/role-management/delete/role',
  ADMIN_ROLE_ADD_PERMISSIONS: '/role-management/add/permissions/:roleId',
  ADMIN_ROLE_DETAILS: '/role-management/details/:roleId',

  ADMIN_TEAMMATES: '/role-management/teammates',
  ADMIN_TEAMMATE_ADD: '/role-management/add/teammate',
  ADMIN_TEAMMATE_UPDATE: '/role-management/update/teammates',
  ADMIN_TEAMMATE_DELETE: '/role-management/delete/teammates/:teammateId',
  ADMIN_TEAMMATE_DETAILS: '/role-management/teammates/details/:teammateId',

  // User Sync for Admin
  USER_ADMIN_ALL: '/user/rapidoo-admin/all',
  USER_ADMIN_REGISTER: '/user/rapidoo-admin/register',
  USER_ADMIN_UPDATE: '/user/rapidoo-admin/update',
  USER_ADMIN_DELETE: '/user/rapidoo-admin/delete',

  // Finance Management
  ADMIN_WALLETS: '/admin/wallets',
  ADMIN_TRANSACTIONS: '/rapidoo-transactions/list',
  ADMIN_WITHDRAWALS: '/admin/withdrawals',
  ADMIN_UPDATE_WITHDRAWAL_STATUS: '/admin/withdrawals/:withdrawalId/status',
  ADMIN_BALANCES: '/rapidoo-aggregation/admin/balances',

  // KYC Management - MonRapidoo API
  KYC_LIST: '/kyc/list',
  KYC_DETAILS: '/kyc/details/:kycId',
  KYC_CREATE_DRAFT: '/kyc/create/draft',
  KYC_UPDATE: '/kyc/update/:kycId',
  KYC_SUBMIT: '/kyc/submit/:kycId',
  KYC_VALIDATE: '/kyc/validate/:kycId',
  KYC_REJECT: '/kyc/reject/:kycId',
  KYC_DELETE: '/kyc/delete/:kycId',

  // Marketing Admin
  ADMIN_PROMOTIONS: '/deals/list',
  ADMIN_DEALS_AGGREGATED: '/rapidoo-aggregation/deals',
  ADMIN_DEALS_ADD: '/deals/add',
  ADMIN_DEALS_UPDATE: '/deals/update/:id',
  ADMIN_DEALS_DETAILS: '/deals/details/:id',
  ADMIN_DEALS_ACTIVATE: '/deals/activate/:id',
  ADMIN_DEALS_DEACTIVATE: '/deals/deactivate/:id',
  ADMIN_DEALS_DELETE: '/deals/delete/:id',

  // Settings Admin
  SETTINGS_BY_KEY: '/settings/byKey',
  SETTINGS_UPDATE: '/settings/update',

  ADMIN_COUPONS: '/coupons/list',
  ADMIN_COUPON_SINGLE: '/coupons/byId/:couponId',
  ADMIN_COUPONS_ADD: '/coupons/create',
  ADMIN_COUPONS_UPDATE: '/coupons/update/:id',
  ADMIN_COUPONS_DELETE: '/coupons/delete/:id',
  ADMIN_COUPONS_VALIDATE: '/coupons/validate',

  ADMIN_ADS: '/ads/list',
  ADMIN_ADS_ADD: '/ads/add',
  ADMIN_ADS_DETAILS: '/ads/details/:id',
  ADMIN_ADS_UPDATE: '/ads/update/:id',
  ADMIN_ADS_ACTIVATE: '/ads/activate/:id',
  ADMIN_ADS_DEACTIVATE: '/ads/deactivate/:id',
  ADMIN_ADS_DELETE: '/ads/delete/:id',

  ADMIN_SPONSORSHIPS: '/sponsorship/list',
  ADMIN_SPONSORSHIP_ADD: '/sponsorship/add',
  ADMIN_SPONSORSHIP_ACCEPT: '/sponsorship/approve/:id',
  ADMIN_SPONSORSHIP_REJECT: '/sponsorship/reject',
  ADMIN_SPONSORSHIP_DETAILS: '/sponsorship/details/:id',
  ADMIN_SPONSORSHIP_DELETE: '/sponsorship/delete/:id',
  ADMIN_SPONSORSHIP_SUGGEST_CORRECTIONS: '/sponsorships/:id/suggest-corrections',
  ADMIN_SPONSORSHIP_BLOCK: '/sponsorships/:id/block',
  ADMIN_SPONSORSHIP_UNBLOCK: '/sponsorships/:id/unblock',
  ADMIN_SPONSORSHIP_UPDATE: '/sponsorships/:id',

  // Settings & Fees
  ADMIN_FEES: '/admin/fees',
  ADMIN_SETTINGS: '/admin/settings',
  ADMIN_DISHES: '/rapidoo-aggregation/products-with-sides',
  DISH_BY_ID: '/rapidoo-aggregation/products-with-sides/:id',

  ADMIN_CATEGORIES: '/categories/list',
  
  ADMIN_NOTIFICATIONS: '/message/list/all',
  ADMIN_NOTIFICATIONS_SEND: '/message/send',
  ADMIN_NOTIFICATIONS_MARK_READ: '/message/mark/read/:notificationId',
  ADMIN_NOTIFICATIONS_MARK_ALL_READ: '/message/mark/all/read',

  // Boutique Rapidoo
  PRODUCTS: '/product/list',
  PRODUCT_BY_ID: '/product/details/:id',
  PRODUCTS_ADD: '/product/add',
  PRODUCTS_UPDATE: '/product/update/:id',
  PRODUCT_ACTIVATE: '/product/activate/:id',
  PRODUCT_DEACTIVATE: '/product/deactivate/:id',
  
  PRODUCT_PURCHASES: '/product/list/buyings',
  PRODUCT_BUYING_CREATE: '/product/create/buying',
  PRODUCT_BUYING_CONFIRM: '/product/confirm/buying',
  PRODUCT_BUYING_PAYMENT_REQUEST: '/queue/broadcast/data/rapidoo-transactions/productPaymentRequest',


  // Client Debts
  CLIENT_DEBTS: '/admin/client-debts',
  CLIENT_DEBTS_BY_USER: '/admin/client-debts/user/:userId',

  // Support Tickets
  SUPPORT_TICKETS_LIST_ALL: '/support-ticket/list/all',
  SUPPORT_TICKETS_ADD: '/support-ticket/add',
  SUPPORT_TICKETS_ADD_MESSAGE: '/support-ticket/add/message/:ticketId',
  SUPPORT_TICKETS_MARK_SOLVED: '/support-ticket/markAsSolved/:ticketId',
  SUPPORT_TICKETS_MARK_UNSOLVED: '/support-ticket/markAsUnsolved/:ticketId',

  // Reward / Fidélité
  REWARD_LEVELS: '/reward/levels',
  REWARD_LEVEL_CREATE: '/reward/level',
  REWARD_LEVEL_UPDATE: '/reward/level/:id',
  REWARD_LEVEL_DETAILS: '/reward/level/:id',
  REWARD_LEVEL_DELETE: '/reward/level/:id',
  REWARD_MILESTONES: '/reward/milestones',
  REWARD_MILESTONE_CREATE: '/reward/milestone',
  REWARD_MILESTONE_UPDATE: '/reward/milestone/:id',
  REWARD_MILESTONE_DELETE: '/reward/milestone/:id',
  REWARD_RULES: '/reward/rules',
  REWARD_RULE_CREATE: '/reward/rule',
  REWARD_RULE_UPDATE: '/reward/rule/:id',
  REWARD_RULE_DELETE: '/reward/rule/:id',
  REWARD_USER_PROFILE: '/reward/profile/:userId',
  REWARD_USER_PROFILE_UPDATE: '/reward/profile/:profileId',
  REWARD_USER_PROGRESS: '/reward/profile/progress/:userId',
  REWARD_USER_MILESTONES: '/reward/profile/milestone/:userId',
  REWARD_ADD_XP: '/reward/profile/xp/:userId',
  REWARD_ADD_POINTS: '/reward/profile/points/:userId',
};


/**
 * Helper pour obtenir le userId actuel
 */
export function getUserId() {
  const userData = Storage.get('userData');
  return userData?.id || userData?.userId || '20b2bb6c-fcfd-4e03-b3e4-aef842c471f3';
}

/**
 * Helper pour construire les URLs avec query params et userId
 * @param {string} endpoint
 * @param {object} config
 */
export function buildApiUrl(endpoint = '', config = {}) {
  const { pathParams = {}, queryParams = {} } = config || {};
  
  let url = `${API_CONFIG.baseURL}${endpoint}`;

  // Remplacer les path params (ex: :orderId)
  Object.keys(pathParams).forEach(key => {
    url = url.replace(`:${key}`, pathParams[key]);
  });

  const urlObj = new URL(url);
  
  // Ajouter le userId et le group
  urlObj.searchParams.set('group', 'ultraxeno');

  // Ajouter les autres query params
  Object.keys(queryParams).forEach(key => {
    if (queryParams[key] !== undefined && queryParams[key] !== null) {
      urlObj.searchParams.set(key, queryParams[key]);
    }
  });

  return urlObj.toString();
}
